import React from "react";
import PropTypes from "prop-types";

/**
 * IndicatorCard component displays a statistical card with an icon, title, value, and description.
 * It is used within the dashboard to present key metrics.
 */
const defaultIndicator = {
  title: "No Data",
  value: "0",
  icon: "fa fa-exclamation-circle",
  colSize: "4",
  bgColor: "bg-secondary",
  progress: 0,
  description: "Select controls to load data",
};

const IndicatorCard = ({
  title,
  value,
  icon,
  colSize,
  bgColor,
  bgStyle,
  progress,
  description,
  className,
}) => {
  return (
    <>
      <div className={`col-xl-${colSize} col-md-6 mb-4`}>
        <div
          className={`widget widget-stats ${
            bgColor ?? defaultIndicator.bgColor
          } m-0 ${className || ""}`}
          style={bgStyle || undefined}
        >
          <div className="stats-icon stats-icon-lg">
            <i className={`${icon || defaultIndicator.icon} fa-fw`}></i>
          </div>
          <div className="stats-content">
            <div className="stats-title">{title || defaultIndicator.title}</div>
            <div className="stats-number">
              {(value*100).toFixed(1) || defaultIndicator.value}
            </div>
            {progress !== "" && progress !== undefined ? (
              <div className="stats-progress progress">
                <div
                  className="progress-bar"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            ) : null}
            <div className="stats-desc">
              {description || defaultIndicator.description}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Add prop types for documentation and validation
IndicatorCard.propTypes = {
  /** Title displayed at the top of the card */
  title: PropTypes.string,

  /** Main numeric value to display (can include formatting) */
  value: PropTypes.string,

  /** FontAwesome icon class name (without 'fa-') */
  icon: PropTypes.string,

  /** String number to define size of the col-xl */
  colSize: PropTypes.string,

  /** Background color class (e.g., 'bg-teal', 'bg-blue', 'bg-indigo', 'bg-dark') */
  bgColor: PropTypes.string,

  /** Progress percentage (0-100) */
  progress: PropTypes.number,

  /** Description text displayed below the progress bar */
  description: PropTypes.string,
};

// Default props
IndicatorCard.defaultProps = {
  title: "TITLE",
  value: "0",
  icon: "fa fa-globe",
  colSize: "3",
  bgColor: "bg-teal",
  progress: 0,
  description: "No change",
};

export default IndicatorCard;
